import { generateRoute } from '@klp/routing';

// Extend AppConfigParameters for frontpage
declare global {
    interface AppConfigParameters {
        WEBAPP_TAGGBOX_ENABLE: boolean;
        WEBAPP_TAGGBOX_URL: string;
        WEBAPP_LINKEDIN_LINK: string;
    }
}

export const FrontpageModuleName = '/';

export const FrontpageRoutes = {
    frontpage: () => generateRoute([FrontpageModuleName]),
};
